module.exports = __webpack_public_path__ + "img/1x1.76e247b0.svg";